import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Check, Play } from "lucide-react";
import { useSettings } from "../context/SettingsContext";
import { track } from "../lib/analytics";
import Seo from "../components/Seo";
import FollowStrip from "../components/FollowStrip";
import RelatedReleases from "../components/RelatedReleases";
import Footer from "../components/Footer";

export default function Thanks() {
  const settings = useSettings();
  useEffect(() => { window.scrollTo(0, 0); track("thank_you_view", {}); }, []);
  return (
    <div data-testid="thanks-page" className="grain relative min-h-screen pb-32">
      <Seo title="You're on the Código List" noindex path="/thanks" />
      <div className="mx-auto max-w-3xl px-6 pt-28 text-center sm:px-10">
        <div className="mx-auto mb-6 inline-flex h-16 w-16 items-center justify-center rounded-full bg-gold/15 text-gold"><Check size={30} /></div>
        <p className="text-xs font-bold uppercase tracking-[0.35em] text-gold">Bienvenido</p>
        <h1 className="mt-3 font-display text-4xl font-bold uppercase tracking-tight text-white sm:text-6xl">You're on the Código List</h1>
        <p className="mt-4 text-base text-white/60">New music, videos, private previews and early drops — you'll hear it first. While you're here, make sure you never miss a release:</p>
        <div className="mt-8 flex justify-center"><FollowStrip settings={settings} placement="thanks" showList={false} /></div>
        <Link to="/" data-testid="thanks-home" className="mt-10 inline-flex items-center gap-2 rounded-full bg-gold px-7 py-4 text-sm font-bold uppercase tracking-wide text-black transition-transform active:scale-95">
          <Play size={16} fill="currentColor" /> Back to the music
        </Link>
      </div>
      <RelatedReleases current={null} overline="Start here" title="Latest from DJ Código" />
      <Footer settings={settings} />
    </div>
  );
}
